import { createAction } from '@reduxjs/toolkit';

import { AppThunkDispatch } from 'data/store';
import { TaxDocument } from 'data/models/taxDocuments';
import { fetchTaxDocumentsByYearAndQid } from 'data/data-layer/taxDocuments';

const SET_TAX_DOCUMENTS = 'SET_TAX_DOCUMENTS';
const ADD_TAX_DOCUMENTS = 'ADD_TAX_DOCUMENTS';

export const setTaxDocuments = createAction<TaxDocument[]>(SET_TAX_DOCUMENTS);
export const addTaxDocuments = createAction<TaxDocument[]>(ADD_TAX_DOCUMENTS);

export const loadTaxDocuments =
  (taxDocuments: TaxDocument[]) =>
  (dispatch: AppThunkDispatch): TaxDocument[] => {
    dispatch(setTaxDocuments(taxDocuments));
    return taxDocuments;
  };

//ToDo: Fetch docs everytime the year is changed and loading them into redux is inefficient. Need to change.
export const loadTaxDocumentsByQIDs =
  (taxYear: number, QIDs: string[]) =>
  async (dispatch: AppThunkDispatch): Promise<TaxDocument[]> => {
    try {
      const taxDocumentPromises = QIDs.map(qid => fetchTaxDocumentsByYearAndQid(taxYear, qid));
      const taxDocumentsByMember = await Promise.all(taxDocumentPromises);
      const taxDocuments = taxDocumentsByMember.flat();
      dispatch(loadTaxDocuments(taxDocuments));
      return taxDocuments;
    } catch (error) {
      return [];
    }
  };

export const unloadTaxDocuments =
  () =>
  (dispatch: AppThunkDispatch): void => {
    dispatch(loadTaxDocuments([]));
  };
